import { ApiService } from '../../root-services/api.service';
import { TimezoneService } from './../../shared/services/timezones.service';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { EditionService } from './../../shared/services/edition.service';
import { EditionListService } from '../../editions/edition.service';
import { ErrorService } from './../../shared/services/error.service';
import { ProfileField } from './../../models/global/profile-field';
import { CurrentUserService } from './../../shared/services/current-user.service';
import { SAMLProvider } from './saml-provider';
import { AuthSettingsService } from './auth-settings.service';

import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-sso-settings',
  templateUrl: './sso-settings.component.html',
  styleUrls: ['./sso-settings.component.less']
})

export class SSOSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('form') form: ElementRef;

  public newProvider: boolean;
  public provider: SAMLProvider;
  public providerForm: FormGroup;
  public attrFormArray: FormArray;
  public profileFields: ProfileField[];
  private _providerId: number;

  constructor(
    private editionList: EditionListService,
    private editionService: EditionService,
    private errorService: ErrorService,
    private authSettingsService: AuthSettingsService,
    private route: ActivatedRoute,
    private router: Router,
    private _fb: FormBuilder,
  ) {}

  public ngOnInit(): void {
    this.attrFormArray = this._fb.array([]);
    this.providerForm = this._fb.group({
      id: null,
      global_ref: null,
      title: null,
      idp_entity_identifier: null,
      edition_id: null,
      idp_sso_url: null,
      idp_certificate: null,
      sp_entity_identifier: null,
      sp_certificate: null,
      sp_private_key: null,
      name_id_format: null,
      authn_requests_signed: false,
      want_assertions_signed: true,
      sign_metadata: true,
      debug: true,
      automatic_provisioning: false,
      profile_field_id: null,
      sso_id_name: null,
      idp_sso_method: null,
      idp_slo_url: null,
      idp_slo_method: null,
      automatic_signin: false,
      group_field_name: null,
      require_preauth: false,
      no_account_message: null,
      sso_optional_message: null,
      button_text: null,
      linked_provider_id: null,
      subscription_id: null,
      first_name_attr: null,
      last_name_attr: null,
      email_attr: null,
      attr_map: this.attrFormArray,
      enabled: false,
      idp_certificate_expiry: null,
      sp_certificate_expiry: null,
    });

    this.route.parent.params.subscribe(params => {
      this._providerId = parseInt(params['id']);

      this.editionList.waitForEdition().subscribe(() => {
        this.getProviderSettings(this._providerId);
      });
    });
  }

  public ngOnDestroy(): void {
    // this.subs.forEach(sub => sub.unsubscribe());
  }

  public save(value, valid): void {
    if (valid) {
      let data: SAMLProvider = {
        id: value.id,
        global_ref: value.global_ref || null,
        title: value.title || null,
        idp_entity_identifier: value.idp_entity_identifier,
        edition_id: value.edition_id,
        idp_sso_url: value.idp_sso_url,
        idp_certificate: value.idp_certificate,
        sp_entity_identifier: value.sp_entity_identifier || null,
        sp_certificate: value.sp_certificate,
        name_id_format: value.name_id_format,
        authn_requests_signed: value.authn_requests_signed,
        want_assertions_signed: value.want_assertions_signed,
        sign_metadata: value.sign_metadata,
        debug: value.debug,
        automatic_provisioning: value.automatic_provisioning,
        profile_field_id: value.profile_field_id ? parseInt(value.profile_field_id) : null,
        sso_id_name: value.sso_id_name || null,
        idp_sso_method: value.idp_sso_method,
        idp_slo_url: value.idp_slo_url || null,
        idp_slo_method: value.idp_slo_method || null,
        automatic_signin: value.automatic_signin,
        group_field_name: value.group_field_name || null,
        require_preauth: value.require_preauth,
        no_account_message: value.no_account_message || null,
        sso_optional_message: value.sso_optional_message || null,
        button_text: value.button_text || null,
        linked_provider_id: value.linked_provider_id ? parseInt(value.linked_provider_id) :  null,
        subscription_id: value.subscription_id ? parseInt(value.subscription_id) :  null,
        first_name_attr: value.first_name_attr,
        last_name_attr: value.last_name_attr,
        email_attr: value.email_attr || null,
        attr_map: value.attr_map.map(mapping => ({name:mapping.name, field_id: parseInt(mapping.field_id)})),
        enabled: value.enabled,
        idp_certificate_expiry: value.idp_certificate_expiry,
        sp_certificate_expiry: value.sp_certificate_expiry
     };
      if (value.sp_private_key) {
        data.sp_private_key = value.sp_private_key;
      }

      let action = this.newProvider ? this.authSettingsService.createProvider(data) : this.authSettingsService.putProviderSettings(data);

      action.subscribe(provider => {
        console.log(provider);
        alert('saved');
        if (this.newProvider) {
          this.router.navigate(['/global-settings', 'sso-settings', provider.id])
        }
      }, error => {
        if (error.type === 'ApiValidationError') {
          error.fields.forEach(fieldError => {
            this.providerForm.controls[fieldError.field].setErrors({incorrect: true});
          });
        }
        alert(error.description);
      });
     }
     else {
       alert('invalid');
     }
  }

  public addAttr(): void {
    this.attrFormArray.push(this._fb.group({
      name: null,
      field_id: null,
    }));
    console.log(this.attrFormArray);
  }

  /**
   * Private Methods
   */

  private getProviderSettings(providerId: number): void {
    this.editionService.getEdition()
      .subscribe(edition => {
        this.profileFields = edition.profile_fields;
        if (providerId) {
          this.newProvider = false;
          this.authSettingsService.getProviderSettings(edition.id, providerId)
            .subscribe(provider => {
              this.provider = provider;
              this.setFormValues();
            });
        }
        else {
          this.newProvider = true;
          this.providerForm.controls.edition_id.setValue(edition.id);
        }
      });
  }

  private setFormValues() {
    let controls = this.providerForm.controls;
    for (let controlName in controls) {
      if (controlName === 'attr_map') {
        this.provider.attr_map.forEach(mapping => {
          let group = this._fb.group({
            name: mapping.name,
            field_id: mapping.field.id,
          });
          (controls[controlName] as FormArray).push(group);
        })
      }
      else {
        controls[controlName].setValue(this.provider[controlName]);
      }
    }
  }
}




// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/auth-settings/sso-settings.component.ts